'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n  margin: ', ';\n  font-family: ', ';\n  font-weight: ', ';\n  font-size: ', ';\n  color: ', ';\n  line-height: ', ';\n  text-decoration: ', ';\n  &:hover {\n    color: ', ';\n    text-decoration: ', ';\n  }\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n'], ['\n  margin: ', ';\n  font-family: ', ';\n  font-weight: ', ';\n  font-size: ', ';\n  color: ', ';\n  line-height: ', ';\n  text-decoration: ', ';\n  &:hover {\n    color: ', ';\n    text-decoration: ', ';\n  }\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n']);

var createStyledLink = function createStyledLink(tag) {
  return styled(tag)(_templateObject, function (props) {
    return props.s.margin || '0.75rem 0';
  }, function (props) {
    return props.s.fontFamily || 'inherit';
  }, function (props) {
    return props.s.fontWeight || 'normal';
  }, function (props) {
    return props.s.fontSize || 'inherit';
  }, function (props) {
    return props.s.color || '#2b7cac';
  }, function (props) {
    return props.s.lineHeight || 1;
  }, function (props) {
    return props.s.textDecoration || 'none';
  }, function (props) {
    return props.s.hoverColor || '#2b7cac';
  }, function (props) {
    return props.s.hoverTextDecoration || 'underline';
  });
};

var StyledAnchorLink = createStyledLink('a');
var StyledButtonLink = createStyledLink('button');

var TextLink = function TextLink(_ref) {
  var s = _ref.s,
      href = _ref.href,
      children = _ref.children,
      target = _ref.target,
      rel = _ref.rel,
      onClick = _ref.onClick;
  return onClick && !href ? React.createElement(
    StyledButtonLink,
    {
      s: s,
      onClick: onClick
    },
    children
  ) : React.createElement(
    StyledAnchorLink,
    {
      s: s,
      href: href,
      target: target,
      rel: target === '_blank' ? 'noopener noreferrer' + (rel ? ' ' + rel : '') : rel,
      onClick: onClick
    },
    children
  );
};

TextLink.defaultProps = {
  s: {},
  target: '_self',
  rel: null,
  onClick: null
};

TextLink.propTypes = {
  s: PropTypes.shape({
    margin: PropTypes.string,
    fontFamily: PropTypes.string,
    fontWeight: PropTypes.string,
    fontSize: PropTypes.string,
    color: PropTypes.string,
    lineHeight: PropTypes.string,
    textDecoration: PropTypes.string,
    hoverColor: PropTypes.string,
    hoverTextDecoration: PropTypes.string
  }),

  // Require an `href` be given if there is no `onClick` prop given
  /* eslint-disable react/require-default-props */
  href: function href(props, propName, componentName) {
    return PropTypes.checkPropTypes({ href: props.onClick ? PropTypes.string : PropTypes.string.isRequired }, props, propName, componentName);
  },
  /* eslint-enable */

  children: PropTypes.string.isRequired,
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  rel: PropTypes.string,
  onClick: PropTypes.func
};

exports.default = TextLink;
//# sourceMappingURL=index.js.map
